export default __webpack_public_path__ + "static/media/icon_stoneshape_Princess.f7dd4b25.png";